import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import moment from 'moment';
import React from 'react';
import { validTimestampDatePickerOperators } from '../utils';
import { DateFilterComponent } from './DateFilterComponent';
import { TextFilterComponent } from './TextFilterComponent';
var placeholder = moment().toJSON();
export var TimestampHandlerComponentFactory = function TimestampHandlerComponentFactory(props) {
  // Because many dates are stored, and must be queried as, a valid TIMESTAMP
  // It is easier to do [EQ,NE] with a text field, copy/paste "2021-06-21T10:04:47-07:00" from table
  // // If trying to use a datepicker, the time segments of the string would never match perfectly
  // It is easier to do [GE, LE] with a datepicker, pick June 22, 2021, get those dates
  // // If trying to use a text field, a full timestamp string would have to be provided
  return validTimestampDatePickerOperators(props.state[props.stateKey].operator) ? /*#__PURE__*/React.createElement(DateFilterComponent, props) : /*#__PURE__*/React.createElement(TextFilterComponent, _extends({}, props, {
    dsComponentProps: _objectSpread(_objectSpread({}, props.dsComponentProps), {}, {
      placeholder: placeholder
    })
  }));
};

try {
  TimestampHandlerComponentFactory.__docgenInfo = {
    description: '',
    displayName: 'TimestampHandlerComponentFactory',
    methods: [],
    props: {}
  };
} catch (e) {}
//# sourceMappingURL=TimestampHandlerComponentFactory.js.map